<template>
    <div class="panel mb-0">
        <div class="panel-hdr d-block pt-4 p-3">
            <div class="ml-auto export-button text-right mb-3">
                <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                    :data="exportData"
                    :fields="exportFields"
                    :header="exportHeaders"
                    type="csv"
                    :escapeCsv="false"
                    :name="exportFileName">
                    <span>CSV</span>
                </exportCSV>
                <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                    <span class="mr-3">PDF</span>
                    <i class="arrow-down fas fa-angle-down"></i> 
                </button> -->
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 align-items-center justify-content-start mb-2">
                    <div class="dataTables_filter">
                        <label class="d-flex mb-0">
                            <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchMember" @keypress.enter="searchMemberList">
                            <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0" @click="searchMemberList">
                                <i class="fas fa-search"></i>
                            </button>
                        </label>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 mb-2">
                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0" >
                                    <i class="fas fa-store"></i>
                                </label>
                                <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet"></multiselect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a class="link text-primary" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
        </div>
        <div class="panel-container">
            <div class="panel-content">
                <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                    <b-spinner label="Loading..."></b-spinner>
                </div>
                <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
                <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                    <div class="row justify-content-end mt-2">
                        <div class="col-auto pt-2">
                            <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                        </div>
                        <div class="col-auto">
                            <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 overflow-auto">
                            <b-table small striped hover bordered :fields="fields" :items="memberLists" responsive>
                                <template #cell(index)="data">
                                    {{ data.index + startPage }}
                                </template>
                                <template #cell(createDate)="data">
                                    {{convertTimestampToDateTime(data.item.createDate)}}
                                </template>
                                <template #cell(outlet)="data">
                                    {{getOutletName(data.item.outletID)}}
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import tbl from './../../../../assets/js/dashboard/table-header'
import exp from './../../../../assets/js/dashboard/export-table-header'
import {getOutletName, handleSessionExpired, setReturnData} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'memberChangeMobile',
    data(){
        return{
            searchMember: "", isSpinnerShow: false,
            outlet: [{id: "", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}],
            selectedOutlet: {id: "", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})},
            memberLists: [],
            outletFilter: "", searchFilter: "",
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [],
            exportData: [], exportFileName: "", memberExportData: {}
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "createDate", label: this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "outlet", label: this.$i18n.t('table.header.outlet'), thClass: 'thead-themed align-middle'},
                { key: "memberDisplayName", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "oldMobile", label: this.$i18n.t('table.header.oldMobile'), thClass: 'thead-themed align-middle'},
                { key: "mobile", label: this.$i18n.t('table.header.newMobile'), thClass: 'thead-themed align-middle'}
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "date"
            ret[(this.$i18n.t('table.header.outlet')).toUpperCase()] = "outlet"
            ret[(this.$i18n.t('table.header.name')).toUpperCase()] = "name"
            ret[(this.$i18n.t('table.header.oldMobile')).toUpperCase()] = "oldMobile"
            ret[(this.$i18n.t('table.header.newMobile')).toUpperCase()] = "newMobile"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.outlet = [{id: "", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}]
            this.outlet.push(...JSON.parse(this.$store.state.outlets))

            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj=> obj.id == b.id)
            this.setExportData(this.memberExportData)
        }
    },
    methods:{
        getOutletName(id){
            return getOutletName(id, this.outlet)
        },
        convertTimestampToDateTime(ts){
            return moment.unix(ts).format(this.$msg.CST.DATE_TIME_24);
        },
        clearFilter(){
            this.selectedOutlet = this.outlet[0];
            this.outletFilter = this.searchFilter = this.searchMember = ""
            this.filterMemberList(this.outletFilter, this.searchFilter)
        },
        searchMemberList(){
            this.searchFilter = this.searchMember == "" ? "" : "&search=" + this.searchMember;
            this.filterMemberList(this.outletFilter, this.searchFilter)
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.outletFilter = item.id == "" ? "" : "&outletID=" + item.id;
            this.filterMemberList(this.outletFilter, this.searchFilter)
        },
        filterMemberList(outlet, search){
            var strFilter = outlet + search;
            this.setMemberList(strFilter);
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterMemberList(this.outletFilter, this.searchFilter);
            }
        },
        setExportData(members){
            this.exportData = [];
            for(var i=0; i<members.length; i++){
                var data = {}
                data["index"] = i+1;
                data["date"] = this.convertTimestampToDateTime(members[i].createDate)
                data["outlet"] = this.getOutletName(members[i].outletID);
                data["name"] = members[i].memberDisplayName
                data["oldMobile"] = members[i].oldMobile
                data["newMobile"] = members[i].mobile
                this.exportData.push(data)
            }
            var type = this.$i18n.messages[this.$i18n.locale].tab.memberTabLists.filter(obj=> obj.id == 'changeMobile')
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.my_salon_member`) + "(" + type[0].text + ")"
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV
        },
        async setMemberList(strFilter){
            this.isSpinnerShow = true
            var result = await this.getMemberList("?page=" + this.page + strFilter)
            var retData = setReturnData(result.result, result.count, this.page)
            this.memberLists = retData.result;
            this.totalEntries = result.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;

            this.isSpinnerShow = false; 
            var exportResult = await this.getMemberList("?" + strFilter)
            this.memberExportData = exportResult.result
            this.setExportData(exportResult.result)
        },
        async getMemberList(strFilter){    
            let $vm = this
            let url = this.$api.CHANGE_MOBILE + strFilter

            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) { 
                result = response.data
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })

            return result
        }
    },
    mounted(){
        let $vm = this;
        var outlet = JSON.parse($vm.$store.state.outlets);
        $vm.outlet.push(...outlet)
        $vm.selectedOutlet = $vm.outlet[0];

        $vm.filterMemberList($vm.outletFilter, $vm.searchFilter)
    }
}
</script>
<style scoped>
.link, .nav-link{
    cursor: pointer;
}
</style>